<template>
  <div class="table-extended table-layout">
    <div v-for="(tableContent, key) in tableContents" :key="key" class="table-element">
      <div v-if="tableContent.acf_fc_layout === '2_cols'" class="table-2-cols">
        <h4 v-if="tableContent.header"
            :style="{
              'color': tableContent.custom_header_styling.text_color,
              'background-color': tableContent.custom_header_styling.background_color,
            }">
          {{tableContent.header}}
        </h4>
        <table class="table">
          <tr class="row-header">
            <th v-if="tableContent.col_1_header"
                :style="{
                  'color': tableContent.col_1_settings.custom_table_header_styling.text_color,
                  'background-color': tableContent.col_1_settings.custom_table_header_styling.background_color,
                }">
              {{tableContent.col_1_header}}
            </th>
            <th v-if="tableContent.col_2_header"
                :style="{
                  'color': tableContent.col_2_settings.custom_table_header_styling.text_color,
                  'background-color': tableContent.col_2_settings.custom_table_header_styling.background_color,
                }">
              {{tableContent.col_2_header}}
            </th>
          </tr>
          <tr v-for="(row, i) in tableContent.rows" :key="i">
            <td v-html="row.col_1"
                :style="{
                  'width': tableContent.col_1_settings.width ? `${tableContent.col_1_settings.width}%` : false,
                  'color': tableContent.col_1_settings.custom_table_body_styling.text_color,
                  'background-color': tableContent.col_1_settings.custom_table_body_styling.background_color,
                }"></td>
            <td v-html="row.col_2"
                :style="{
                  'width': tableContent.col_2_settings.width ? `${tableContent.col_2_settings.width}%` : false,
                  'color': tableContent.col_2_settings.custom_table_body_styling.text_color,
                  'background-color': tableContent.col_2_settings.custom_table_body_styling.background_color,
                }"></td>
          </tr>
        </table>
      </div>

      <div v-if="tableContent.acf_fc_layout === '3_cols'" class="table-3-cols">
        <h4 v-if="tableContent.header"
            :style="{
              'color': tableContent.custom_header_styling.text_color,
              'background-color': tableContent.custom_header_styling.background_color,
            }">
          {{tableContent.header}}
        </h4>
        <table class="table">
          <tr class="row-header">
            <th v-if="tableContent.col_1_header"
                :style="{
                  'color': tableContent.col_1_settings.custom_table_header_styling.text_color,
                  'background-color': tableContent.col_1_settings.custom_table_header_styling.background_color,
                }">
              {{tableContent.col_1_header}}
            </th>
            <th v-if="tableContent.col_2_header"
                :style="{
                  'color': tableContent.col_2_settings.custom_table_header_styling.text_color,
                  'background-color': tableContent.col_2_settings.custom_table_header_styling.background_color,
                }">
              {{tableContent.col_2_header}}
            </th>
            <th v-if="tableContent.col_3_header"
                :style="{
                  'color': tableContent.col_3_settings.custom_table_header_styling.text_color,
                  'background-color': tableContent.col_3_settings.custom_table_header_styling.background_color,
                }">
              {{tableContent.col_3_header}}
            </th>
          </tr>
          <tr v-for="(row, i) in tableContent.rows" :key="i">
            <td v-html="row.col_1"
                :style="{
                  'width': tableContent.col_1_settings.width ? `${tableContent.col_1_settings.width}%` : false,
                  'color': tableContent.col_1_settings.custom_table_body_styling.text_color,
                  'background-color': tableContent.col_1_settings.custom_table_body_styling.background_color,
                }"></td>
            <td v-html="row.col_2"
                :style="{
                  'width': tableContent.col_2_settings.width ? `${tableContent.col_2_settings.width}%` : false,
                  'color': tableContent.col_2_settings.custom_table_body_styling.text_color,
                  'background-color': tableContent.col_2_settings.custom_table_body_styling.background_color,
                }"></td>
            <td v-html="row.col_3"
                :style="{
                  'width': tableContent.col_3_settings.width ? `${tableContent.col_3_settings.width}%` : false,
                  'color': tableContent.col_3_settings.custom_table_body_styling.text_color,
                  'background-color': tableContent.col_3_settings.custom_table_body_styling.background_color,
                }"></td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    tableContents: null,
  },
};
</script>
<style lang="scss">
@import '@/assets/scss/common.scss';
.table-layout {
  h4 {
    border-top: 1px solid $secondary;
    border-bottom: 1px solid $secondary;
    background-color: #bfebfb;
    font-weight: bold;
    font-size: 17px;
    margin-bottom: 0;
    padding: .5rem .75rem;
    + table {
      border-top: 0!important;
    }
  }
  .table {
    margin-bottom: 0;
    background-color: #f0f0f0;
    border-top: 1px solid $primary;
    th {
      border-top: 0;
      background-color: #c8c7c8;
      font-size: 13px;
      font-weight: 400;
      padding-top: .5rem;
      padding-bottom: .5rem;

    }
    td {
      padding: 1rem .75rem;
      border-top: 0;
      vertical-align: middle;
      p, ul, ol {
        margin-bottom: .5rem;
      }
      p:last-child, ul:last-child {
        margin: 0;
      }
      ul {
        li {
          margin-bottom: .3rem;
        }
        > li:last-child {
          margin: 0;
        }
        @extend .list-square;
      }
    }
    th, td {
      border-bottom: 1px solid $primary;
    }
    tr:last-child td {
      border-bottom: 0;
    }
  }
  .table-element {
    &:last-child table tr td  {
      border-bottom: 1px solid $primary;
    }
  }
}
@include media-breakpoint-down(md) {
  .table-layout {
    h4 {
      font-size: 14px!important;
    }
    th {
      font-size: 10px;
    }
    td {
      font-size: 12px;
    }
  }
}
@include media-breakpoint-down(sm) {
  .table-layout {
    overflow: auto;
    width: 100%;
    .table, h4 {
      width: 700px;
    }
  }
}
</style>
